module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"season1_ended":"Season1 has been ended.<br />\\nSeason2 is available <a href=\\"/app2/\\">here</a>.\\n"},"ja":{"season1_ended":"シーズン1は終了しました。<br />\\nシーズン2は<a href=\\"/app2/\\">こちら</a>\\n"}}')
  delete Component.options._Ctor
}
